<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nICkrv/tc-custom/9780062195678.jpg?1716663322160" alt="This image is the cover for the book Way of the Fight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Way of the Fight
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned UFC fighter tells his remarkable life story from bullied kid to world champion in this <i>New York Times</i>–bestselling memoir.</b><br/><br/>For mixed martial arts fighter Georges St-Pierre, the greatest asset is not physical strength or athleticism—it’s a sense of purpose. From his beginnings as a small, mercilessly bullied child first discovering karate to his years as a struggling garbage collector who spent all his free time in the gym, his hard-fought rise in the sport of mixed martial arts, and his long, painful recovery from a career-threatening injury, Georges never lost sight of his ambition to become the greatest martial artist of all time. In <i>The Way of the Fight</i>, Georges reveals what propelled him not only to become a champion but to embrace obstacles as opportunities to build character.<br/><br/><i>The Way of the Fight</i> is an inspirational look into the mindset of a master. To Georges, all life is competition, and there’s no more perfect metaphor for competition than the life of a fighter. He explains the value of discipline, risk and even fear, with the wisdom of one who knows that his next fight could always be his last. Drawing inspiration from fighting legends, Eastern philosophy and a trusted inner circle, <i>The Way of the Fight</i> is a powerful, life-changing guide to living with purpose.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Georges St-Pierre
      </h2>
      
      <p class="authorDescription body article"><P>Georges "Rush" St-Pierre, also known as "GSP," is a Canadian professional mixed martial artist and world champion who holds black belts in both Kyokushin karate and Brazilian Jiu-Jitsu. Recog-nized as one of the planet's best pound-for-pound MMA fighters and all-around athletes, as well as a three-time Canadian Athlete of the Year, GSP lives in Montreal and travels around the world to work with the best coaches and training partners in all disciplines.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c118b82